// Reserve the homepage pagination row (70px bottom offset + 24px line box),
// a 40px desktop CTA and 16px separation. Mobile uses its own CTA anchor.
const getHomepageCtaInfo = (info, hasTaggedProducts = false) => {
  if (!info?.top || info.top === 'auto') return info

  // Right-aligned CTAs can also share the tagged-look control's horizontal
  // space on narrow tablets: 100px bottom + 46px control + 20px gap + 40px CTA.
  const clearance = hasTaggedProducts && info.position === 'right' ? 206 : 150

  return {
    ...info,
    top: `min(${
      info.top === '0' ? '0px' : info.top
    }, calc(100% - ${clearance}px))`,
  }
}

export default getHomepageCtaInfo
